<mat-form-field>
  <mat-select placeholder="DocumentType" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let docType of dmsDocumentTypes" [value]="docType">
      {{ docType }}
    </mat-option>
  </mat-select>
</mat-form-field>
